import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ChatHistory from 'pages/chatHistory/ChatHistory';

const ChatHistoryRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<ChatHistory />} />
    </Routes>
  );
};

export default ChatHistoryRouter;